import withFetch from './withFetch';
import {
  CREATE_REPORT_TENANT, GET_CURRENT_REPORT_TENANT, GET_REPORTS_TENANT, SOFT_DELETE_REPORT_TENANT, UPDATE_REPORT_TENANT,
} from '../fetchTypes';
import { EDIT_REPORT, LOG_OUT } from '../sharedTypes';

const createInitialState = () => ({
  loading: false,
  loaded: false,
  updating: false,
  editingReport: null,
  totalReports: 0,
  reports: [],
  currentReport: null,
  loadingCurrent: false,
  loadedCurrent: false,
  errorCurrent: undefined,
});

const fetchRequestReducer = (state, action) => {
  switch (action.fetchType) {
    case GET_REPORTS_TENANT:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: undefined,
      };
    case GET_CURRENT_REPORT_TENANT:
      return {
        ...state,
        loadingCurrent: true,
        errorCurrent: undefined,
      };
    case CREATE_REPORT_TENANT:
    case UPDATE_REPORT_TENANT:
      return {
        ...state,
        updating: true,
        updateError: undefined,
      };
    default:
      return state;
  }
};

const fetchSuccessReducer = (state, action) => {
  switch (action.fetchType) {
    case GET_REPORTS_TENANT:
      return {
        ...state,
        loading: false,
        loaded: true,
        reports: action.data.reports,
        totalReports: action.data.reports.length,
      };
    case GET_CURRENT_REPORT_TENANT:
      return {
        ...state,
        loadingCurrent: false,
        loadedCurrent: true,
        currentReport: action.data.report,
      };
    case CREATE_REPORT_TENANT:
    case UPDATE_REPORT_TENANT:
      return {
        ...state,
        loading: false,
        loaded: false,
        updating: false,
        editingReport: null,
      };
    case SOFT_DELETE_REPORT_TENANT:
      return {
        ...state,
        reports: state.reports.filter(({ _id }) => _id !== action.reqData._id),
        totalReports: state.totalReports - 1,
        currentReport: state.currentReport && state.currentReport._id === action.reqData._id ? {
          ...state.currentReport,
          isActive: false,
        } : state.currentReport,
      };
    default:
      return state;
  }
};

const fetchErrorReducer = (state, action) => {
  switch (action.fetchType) {
    case GET_REPORTS_TENANT:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case GET_CURRENT_REPORT_TENANT:
      return {
        ...state,
        loadingCurrent: false,
        errorCurrent: action.error,
      };
    case CREATE_REPORT_TENANT:
    case UPDATE_REPORT_TENANT:
      return {
        ...state,
        updating: false,
        updateError: action.error,
      };
    default:
      return state;
  }
};

const defaultReducer = (state, action) => {
  switch (action.type) {
    case LOG_OUT:
      return createInitialState();
    case EDIT_REPORT:
      return {
        ...state,
        editingReport: action.data,
      };
    default:
      return state;
  }
};

export default withFetch(createInitialState(),
  fetchRequestReducer, fetchSuccessReducer, fetchErrorReducer, defaultReducer);
